webpackJsonp([191319344601756],{

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(14);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by vaibhav on 2/4/18
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	function encode(data) {
	  return Object.keys(data).map(function (key) {
	    return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
	  }).join('&');
	}
	
	var Contact = function (_React$Component) {
	  _inherits(Contact, _React$Component);
	
	  function Contact(props) {
	    _classCallCheck(this, Contact);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleChange = function (e) {
	      var _this$setState;
	
	      _this.setState((_this$setState = {}, _this$setState[e.target.name] = e.target.value, _this$setState));
	    };
	
	    _this.handleSubmit = function (e) {
	      fetch('/', {
	        method: 'POST',
	        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	        body: encode(_extends({ 'form-name': 'contact' }, _this.state))
	      }).then(function () {
	        return alert('Your message has been sent.');
	      }).catch(function (error) {
	        return alert(error);
	      });
	
	      e.preventDefault();
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  Contact.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'section',
	        { className: 'hero is-primary is-bold' },
	        _react2.default.createElement(
	          'div',
	          { className: 'hero-body' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'columns' },
	              _react2.default.createElement(
	                'div',
	                { className: 'column is-10 is-offset-2' },
	                _react2.default.createElement('div', { className: 'section' })
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'body section is-paddingless' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            _react2.default.createElement(
	              'div',
	              { className: 'columns' },
	              _react2.default.createElement(
	                'div',
	                { className: 'column is-12 is-offset-2 slide-up' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'content column is-4' },
	                  _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Contact Us'
	                  ),
	                  _react2.default.createElement(
	                    'form',
	                    {
	                      name: 'contact',
	                      method: 'post',
	                      action: '/thanks/',
	                      'data-netlify': 'true',
	                      'data-netlify-honeypot': 'bot-field',
	                      onSubmit: this.handleSubmit
	                    },
	                    _react2.default.createElement(
	                      'p',
	                      { hidden: true },
	                      _react2.default.createElement(
	                        'label',
	                        { 'class': 'label' },
	                        'Don\u2019t fill this out: ',
	                        _react2.default.createElement('input', { name: 'bot-field' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'field' },
	                      _react2.default.createElement(
	                        'label',
	                        { 'class': 'label' },
	                        'Name'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'control' },
	                        _react2.default.createElement('input', {
	                          'class': 'input is-radiusless is-shadowless',
	                          type: 'text',
	                          onChange: this.handleChange
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'label',
	                      { 'class': 'label' },
	                      'Email'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'control' },
	                      _react2.default.createElement('input', {
	                        'class': 'input is-radiusless is-shadowless',
	                        type: 'email',
	                        name: 'email',
	                        onChange: this.handleChange
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'field' },
	                      _react2.default.createElement(
	                        'label',
	                        { 'class': 'label' },
	                        'Message'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'control' },
	                        _react2.default.createElement('textarea', {
	                          name: 'message',
	                          'class': 'textarea is-radiusless is-shadowless',
	                          onChange: this.handleChange
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'button',
	                      { type: 'submit', 'class': 'button is-link' },
	                      'Send'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Contact;
	}(_react2.default.Component);
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-contact-page-js-f7f92109b1a802bb4335.js